module.exports = __webpack_public_path__ + "media/images/emblems/Delemont_coat_of_arms-2ff0d2419030474c6688dbfbb0e0e1bf.svg";